import script from "./BorderLine.vue?vue&type=script&lang=ts&setup=true"
export * from "./BorderLine.vue?vue&type=script&lang=ts&setup=true"

import "./BorderLine.vue?vue&type=style&index=0&id=8346cf6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8346cf6c"]])

export default __exports__